import {Component, Input, OnInit} from '@angular/core';
import {TilesService} from "../../core";

@Component({
    selector: 'indicated-value',
    templateUrl: './indicated-value.component.html',
    styleUrls: ['./indicated-value.component.scss']
})
export class IndicatedValueComponent implements OnInit {
    @Input() angleEnd: number;
    @Input() value: number;
    circlePath: string;
    circlePathBg: string;

    constructor(
        private tiles: TilesService,
    ) {
    }

    ngOnInit() {
        const angleEnd = this.angleEnd ? this.angleEnd : 0;
        this.circlePathBg = this.tiles.calculateCirclePoints(25, 25, 24, 0, 180, 12).toString();
        this.circlePath = this.tiles.calculateCirclePoints(25, 25, 24, 0, angleEnd, 12).toString();
    }
}
